<template>
  <v-list
    dense
    flat
  >
    <!-- <v-list-group
      class="aside-menu-list-group"
      color="#FFF"
      v-for="(grupo, grupoKey) in route" :key="grupoKey">

      <template v-slot:activator>
        <v-list-item-icon>
          {{ getIcon[grupoKey] }}
          <v-img width="24" contain :src="getIcon[grupoKey]" />
        </v-list-item-icon>
        <v-list-item-title> {{ grupoKey }} </v-list-item-title>
      </template>

      <template v-for="(subgrupo, subgrupoKey) in grupo">
        <template v-if="subgrupo.length > 1">
          <v-list-group
            :key="subgrupoKey"
            sub-group
            color="#FFF">
            <v-icon slot="appendIcon" large size="24">mdi-chevron-down</v-icon>

            <template v-slot:activator>
              <v-list-item-title> {{ subgrupoKey }} </v-list-item-title>
            </template>

            <template v-for="item in subgrupo">
              <v-list-item ripple class="aside-menu-list-group--link" :key="item.path" :to="{ name: item.path }" v-if="item.path !== '' && item.meta.show != false">
                <v-list-item-icon class="icon-oval">
                  <img width="6" contain :src="getIcon['oval']" />
                </v-list-item-icon>
                <v-list-item-title> {{ item.realName }} </v-list-item-title>
              </v-list-item>
            </template>
          </v-list-group>
        </template>

        <template v-else>
          <template v-for="item in subgrupo">
            <v-list-item ripple class="aside-menu-list-group--link" :key="item.name" :to="{ name: item.name }" v-if="item.name !== '' && item.meta.show != false">
              <v-list-item-icon class="icon-oval">
                <img width="6"  contain :src="getIcon['oval']" />
              </v-list-item-icon>
              <v-list-item-title> {{ item.realName }} </v-list-item-title>
            </v-list-item>
          </template>
        </template>
      </template>
    </v-list-group> -->
    <v-list-item-group
          class="aside-menu-list-group"
          color="#FFF">
      <v-list-item :to="{ name: grupo.name }" ripple class="aside-menu-list-group--link" v-for="(grupo, grupoKey) in route" :key="grupoKey">
        <v-list-item-icon class="icon-oval">
          <img contain :src="getIcon[grupo.name]" v-if="getIcon[grupo.name]" />
          <img contain :src="default2" v-else />
          <!-- {{ grupo.realName }} -->
          <!-- {{ getIcon[grupo.realName] }} -->
          
        </v-list-item-icon>
        <v-list-item-title> {{ grupo.realName }} </v-list-item-title>
      </v-list-item>
    </v-list-item-group>

    <!-- <v-container>
      <v-divider />
    </v-container> -->

    <!-- <div class="aside-menu-list-group" color="#FFF">
      <v-list-item ripple class="aside-menu-list-group--link" @click="abrirPerfil()">
        <v-list-item-icon class="icon-oval">
          <img contain src="@/assets/img/settings.svg" />
        </v-list-item-icon>
        <v-list-item-title> Configurações </v-list-item-title>
      </v-list-item>

      <v-list-item ripple class="aside-menu-list-group--link" @click="$emit('logout')">
        <v-list-item-icon class="icon-oval">
          <img contain src="@/assets/img/logout.svg" />
        </v-list-item-icon>
        <v-list-item-title> Sair </v-list-item-title>
      </v-list-item>
    </div> -->
  </v-list>
</template>

<script>
import dashboard from '@/assets/icons-aside/home.svg'
import wallet from '@/assets/icons-aside/ion_wallet-outline.svg'
import links from '@/assets/icons-aside/rocket_launch.svg'
import article from '@/assets/icons-aside/article.svg'
import codeBlocks from '@/assets/icons-aside/code_blocks.svg'
import description from '@/assets/icons-aside/description.svg'
import register from '@/assets/icons-aside/how_to_reg.svg'
import pos from '@/assets/icons-aside/point-of-sale.svg'
// import handshake from '@/assets/img/handshake.svg'
// import developerBoard from '@/assets/img/developer_board.svg'
// import settingsBRoll from '@/assets/img/settings_b_roll.svg'
// import findInPage from '@/assets/img/find_in_page.svg'
// import addChart from '@/assets/img/add_chart.svg'
// import analytics from '@/assets/img/analytics.svg'
// import article from '@/assets/img/article.svg'
// import settings from '@/assets/img/settings.svg'
// import logout from '@/assets/img/logout.svg'
// import oval from '@/assets/img/oval.svg'
// import person from '@/assets/img/person.svg'
import Events from '@/core/service/events'
import { mapActions } from 'vuex'

export default {
  name: 'BrMenuItem',
  props: {
    route: {
      type: Array || Object
    }
  },
  components: {
  },
  computed: {
    isVisible: () => (this.route.meta && (this.route.meta.visible === undefined || this.route.meta.visible)) ? !!1 : !!0,
    getIcon () {
      return {
        'afiliados-painel': dashboard,
        'carteira': wallet,
        'links': links,
        'pixel': codeBlocks,
        'afiliados-relatorios': description,
        'cadastros-afiliados': register,
        'instalacoess': pos,
      }
    },
    // default: () => article
    default2 () {
      return article
    },
  },
  methods: {
    name (name) {
     return  String(name)
        .toLowerCase()
        .split("-")
        .map(s => s.charAt(0).toUpperCase() + s.slice(1))
        .join(" ")
    },
    ...mapActions('users', ['getItens']),
    abrirPerfil () {
      this.getItens({ self: true }).then( result => {
      Events.$emit('perfil::openModalPerfil', result.data.mapResult[0])
    }).catch(e => { console.log(e) })},
   }
 }
</script>

<style lang="scss" scoped>
  .aside-menu-list-group::v-deep {
    border-bottom: 0 !important;
    .v-list-group__header > .v-list-item__title {
      text-transform: uppercase !important;
    }
    .v-list-item .v-list-item__icon {
      margin-right: 11px;
    }

    .v-list-group--sub-group .v-list-group__items .v-list-item {
      padding-left: 20px;
    }

    .v-list-group__header > .v-list-group__header__append-icon .v-icon  {
      transform: rotate(-90deg)
    }

    &.v-list-group--active .v-list-group__header > .v-list-group__header__append-icon .v-icon  {
      transform: rotate(0deg)
    }

    .aside-menu-list-group--link {
      min-height: 38px !important;
      padding: 4px 16px;
      margin: 0 12px;
      border: 0;
      border-radius: 10px;
      transition: background-color 0.2s ease, transform 0.15s ease;

      &:hover {
        background-color: rgba(255, 255, 255, 0.06);
        transform: translateX(2px);
      }

      &.v-list-item--active {
        &::before {
          background: var(--v-primary-base);
          opacity: 0.14;
          border-radius: 10px;
        }

        .v-list-item__title {
          color: var(--v-primary-base);
          font-weight: 600;
        }
      }
    }
  }

  .icon-oval {
    display: flex;
    justify-content: flex-end;
    min-width: 6px;
  }

  .v-application--is-ltr .v-list-item__action:first-child,
  .v-application--is-ltr .v-list-item__icon:first-child  {
    margin-right: 10px;
  }
</style>
